import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import validarAvaliacao from "./helperFunctions/validation";

import uuid from "react-uuid";
import toast from "react-hot-toast";
import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import ElementoAvaliacao from "./Elemento/ElementoAvaliacao";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";

import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useLoading } from "../../../shared/context/LoadingContext";
import "../../../shared/css/PlanoAvaliacaoOrcamento.scss";
import "../../../style/formError.scss";

const DENTES_CRIANCAS = [
  "51",
  "52",
  "53",
  "54",
  "55",
  "61",
  "62",
  "63",
  "64",
  "65",
  "71",
  "72",
  "73",
  "74",
  "75",
  "81",
  "82",
  "83",
  "84",
  "85",
  "Arcada Superior",
  "Arcada Inferior",
  "Arcadas",
];
const DENTES_ADULTOS = [
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
];
const DENTES = [...DENTES_ADULTOS, ...DENTES_CRIANCAS];

function NewAvaliacao() {
  const { startLoading, stopLoading } = useLoading();
  const auth = useContext(AuthContext);
  const [medicoResponsavel, setMedicoResponsavel] = useState(
    auth.role === "Secretária(o)" || auth.role === "Assistente"
      ? auth.usuariosAssociados.length === 1
        ? auth.usuariosAssociados[0].id
        : ""
      : null
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cliente, setCliente] = useState();
  const [tratamentos, setTratamentos] = useState();
  const [tratamentosAutocomplete, setTratamentosAutocomplete] = useState();
  const [shortcuts, setShortcuts] = useState([]);
  const [showDentesShortcutModal, setShowDentesShortcutModal] = useState(false);
  const [shortcutAtual, setShortcutAtual] = useState(null);
  const [dentesSelecionadosShortcut, setDentesSelecionadosShortcut] = useState(
    []
  );
  const [touched, setTouched] = useState(false);

  const [serviceList, setServiceList] = useState([
    {
      id: "1",
      dentesTratados: [],
      faces: [],
      show: true,
      erro: "",
      aceitaDentes: true,
    },
  ]);
  const [observacoes, setObservacoes] = useState("");

  const { sendRequest } = useHttpClient();
  const clinica = useContext(ClinicaContext);

  const [showCancelDialog, setShowCancelDialog] = useState(false);

  const temporary = useParams().clienteId;
  let clienteId;
  let marcacaoId;
  let agendamentoProvisorioId;

  if (temporary.split("-").length === 2) {
    clienteId = temporary.split("-")[0];
    marcacaoId = temporary.split("-")[1];
  } else if (temporary.split("-").length === 3) {
    clienteId = temporary.split("-")[0];
    agendamentoProvisorioId = temporary.split("-")[2];
  } else {
    clienteId = temporary;
  }
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        // Fetch tratamentos and cliente in parallel
        const [tratamentosResponse, clienteResponse, shortcutsResponse] =
          await Promise.all([
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentos/populated/${clinica.clinica._id}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token }
            ),
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/${clienteId}?clinicaId=${clinica.clinica._id}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token }
            ),
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/shortcutsavaliacao/${clinica.clinica._id}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token }
            ),
          ]);

        // Process tratamentos data
        const sortedTratamentos = sortTratamentos(
          tratamentosResponse.tratamentos
        );
        setTratamentos(sortedTratamentos);
        setTratamentosAutocomplete(
          formatTratamentosAutocomplete(sortedTratamentos)
        );
        updateServiceList(sortedTratamentos[0]);

        setCliente(clienteResponse.cliente);

        setShortcuts(shortcutsResponse.shortcuts || []);
      } catch (err) {
        console.error("Erro ao buscar dados:", err);
        // Trate o erro (por exemplo, mostre uma mensagem de erro ao usuário)
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [sendRequest, clinica, auth.token, clienteId]);

  // Helper functions
  ////////////////////////////////////////////////////////
  const sortTratamentos = (tratamentos) => {
    const naturalCompare = (a, b) => {
      const ax = [],
        bx = [];
      a.designacao.replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
        ax.push([$1 || Infinity, $2 || ""]);
      });
      b.designacao.replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
        bx.push([$1 || Infinity, $2 || ""]);
      });
      while (ax.length && bx.length) {
        const an = ax.shift(),
          bn = bx.shift();
        const nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
        if (nn) return nn;
      }
      return ax.length - bx.length;
    };
    return tratamentos.sort(naturalCompare);
  };

  const formatTratamentosAutocomplete = (tratamentos) => {
    // A avaliação é independente do preço/fornecedor: mostramos apenas um
    // tratamento por designação (as variantes por fornecedor são escolhidas
    // mais tarde, no orçamento). Representante: variante sem fornecedor, se
    // existir, senão a primeira.
    const porDesignacao = new Map();
    tratamentos.forEach((t) => {
      if (!porDesignacao.has(t.designacao)) {
        porDesignacao.set(t.designacao, []);
      }
      porDesignacao.get(t.designacao).push(t);
    });

    return Array.from(porDesignacao.values())
      .map((grupo) => grupo.find((t) => !t.fornecedor) || grupo[0])
      .map((t) => ({
        id: t.id,
        label: t.designacao,
        categoria: t.categoria.categoria,
      }));
  };

  const updateServiceList = (firstTratamento) => {
    setServiceList((currentServiceList) => [
      {
        ...currentServiceList[0],
        tratamento: firstTratamento.id,
        aceitaDentes: firstTratamento.aceitaDentes,
      },
    ]);
  };
  ///////////////////////////////////////////////

  //funcoes executadas pelas childs
  const tratamentoChangeHandler = (id, tratamento, acDentes, erro) => {
    let list = serviceList;

    const servico = list.filter((el) => {
      return el.id === id;
    });

    const indice = list.indexOf(servico[0]);

    list[indice].tratamento = tratamento;
    list[indice].erro = erro;
    list[indice].aceitaDentes = acDentes;
    setServiceList(list);
    setTouched(true);
  };

  const dentesChangeHandler = (id, dentes, erro) => {
    let list = serviceList;

    const servico = list.filter((el, i) => {
      return el.id === id;
    });
    const indice = list.indexOf(servico[0]);

    list[indice].dentesTratados = dentes;
    list[indice].erro = erro;
    setServiceList(list);
    setTouched(true);
  };

  const facesChangeHandler = (id, faces, erro) => {
    let list = serviceList;

    const servico = list.filter((el, i) => {
      return el.id === id;
    });
    const indice = list.indexOf(servico[0]);

    list[indice].faces = faces;
    list[indice].erro = erro;
    setServiceList(list);
    setTouched(true);
  };

  const addService = () => {
    setServiceList([
      ...serviceList,
      {
        id: uuid(),
        tratamento: tratamentos[0].id,
        dentesTratados: [],
        faces: [],
        show: true,
        erro: "",
        aceitaDentes: tratamentos[0].aceitaDentes,
      },
    ]);
    setTouched(true);
  };

  const removeService = (id) => {
    const list = [...serviceList]; // Clone do array

    const servico = list.find((el) => el.id === id);
    const indice = list.indexOf(servico);

    list[indice] = { ...list[indice], show: false }; // Mantém as outras propriedades
    setServiceList(list);
    setTouched(true);
  };

  const submitHandler = async () => {
    startLoading();
    try {
      // Initial validation
      const filteredServiceList = [];
      let erroServiceList = "";
      const formErrorMessage = validarAvaliacao(serviceList, tratamentos);

      // Check for service errors
      for (const service of serviceList) {
        if (service.erro) {
          erroServiceList = service.erro;
          break;
        }
      }

      if (formErrorMessage || erroServiceList) {
        toast.error(`${formErrorMessage || erroServiceList}`);
        return;
      }

      // Process service list
      serviceList.forEach((service) => {
        if (service.show) {
          filteredServiceList.push({
            tratamento: service.tratamento,
            dentes: service.dentesTratados,
            faces: service.faces,
          });
        }
      });

      // Create final services array
      let finalServices = [];
      filteredServiceList.forEach((service) => {
        if (service.dentes.length > 1) {
          const tratamento_filtrado = tratamentos.find(
            (t) => t.id === service.tratamento
          );

          if (tratamento_filtrado.multiDentes) {
            finalServices.push({
              tratamento: service.tratamento,
              dente: service.dentes.join(", "),
              faces: service.faces,
              orcamentado: false,
            });
          } else {
            service.dentes.forEach((d) => {
              finalServices.push({
                tratamento: service.tratamento,
                dente: d,
                faces: service.faces,
                orcamentado: false,
              });
            });
          }
        } else {
          finalServices.push({
            tratamento: service.tratamento,
            dente: service.dentes[0],
            faces: service.faces,
            orcamentado: false,
          });
        }
      });

      // Prepare avaliação data
      const avaliacaoFormData = new FormData();
      avaliacaoFormData.append("observacoes", observacoes);
      avaliacaoFormData.append("cliente", clienteId);
      avaliacaoFormData.append(
        "medico_responsavel",
        auth.role === "Dentista" || auth.role === "Médico/Administrador"
          ? auth.userId
          : medicoResponsavel
      );
      avaliacaoFormData.append("ativo", true);
      avaliacaoFormData.append("procedimentos", JSON.stringify(finalServices));
      avaliacaoFormData.append("clinica", clinica.clinica._id);
      avaliacaoFormData.append("criado_por", auth.userId);

      // Create avaliação
      const avaliacaoRetornada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes`,
        "POST",
        avaliacaoFormData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      //MARCAR O AGENDAMENTO COMO ATENDIDO
      if (marcacaoId) {
        const formDataAgendamento = new FormData();
        formDataAgendamento.append("marcacaoId", marcacaoId);

        try {
          await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/${
              clinica.clinica?.configuracoes?.configuracoes?.tipoAgendamento
                ?.tipo === "Tratamento"
                ? "agendatratamento"
                : "agenda"
            }/marcaratendido/${marcacaoId}`,
            "PATCH",
            formDataAgendamento,
            {
              Authorization: "Bearer " + auth.token,
            }
          );
        } catch (err) {
          console.error("err", err);
        }
      }

      //CONFIRMAR AGENDAMENTO PROVISORIO
      if (agendamentoProvisorioId) {
        try {
          await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosprovisorio/confirmar/${agendamentoProvisorioId}`,
            "PATCH",
            null,
            {
              Authorization: "Bearer " + auth.token,
            }
          );
        } catch (err) {
          console.error("err", err);
        }
      }

      ////////////////////////////////////////////////////////////////////
      // Prepare notification data
      const notificationFormData = new FormData();
      notificationFormData.append("cliente", clienteId);
      notificationFormData.append("clinica", clinica.clinica._id);
      notificationFormData.append(
        "medicoId",
        auth.role === "Dentista" || auth.role === "Médico/Administrador"
          ? auth.userId
          : medicoResponsavel
      );

      notificationFormData.append(
        "medicoNome",
        auth.role === "Dentista" || auth.role === "Médico/Administrador"
          ? auth.nome
          : auth.usuariosAssociados.find((m) => m.id === medicoResponsavel).nome
      );

      // Determine notification recipients based on role
      let notificationUsers = [];
      if (auth.role === "Médico/Administrador" || auth.role === "Dentista") {
        notificationUsers = auth.usuariosAssociados.map((u) => u.id);
      } else if (auth.role === "Secretária(o)") {
        // const assistentes = auth.assistentesDoMedico
        //   ? auth.assistentesDoMedico.find(
        //       (m) => m.medicoId === medicoResponsavel
        //     ).assistentes
        //   : [];
        // notificationUsers = [medicoResponsavel, ...assistentes];
        notificationUsers = [medicoResponsavel];
      } else if (auth.role === "Assistente") {
        const secretarias = auth.secretariasDoMedico
          ? auth.secretariasDoMedico.find(
              (m) => m.medicoId === medicoResponsavel
            ).secretarias
          : [];
        notificationUsers = [medicoResponsavel, ...secretarias];
      }

      notificationFormData.append("user", JSON.stringify(notificationUsers));
      notificationFormData.append("tipo", "efetuou avaliação");
      notificationFormData.append(
        "mensagem",
        `${auth.nome} criou uma avaliação para ${cliente.nome}`
      );
      notificationFormData.append(
        "dados",
        JSON.stringify({
          avaliacaoId: avaliacaoRetornada.avaliacao._id,
        })
      );

      // Create notification
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/notificacoes`,
        "POST",
        notificationFormData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      toast.success("Avaliação adicionada com sucesso!");
      navigate(`../../../clientes/${clienteId}-avaliacao`);
    } catch (err) {
      console.error("Error in submission:", err);
      toast.error("Erro ao criar avaliação ou notificação");
    } finally {
      stopLoading();
      setIsSubmitting(false);
    }
  };

  const preSubmitHandler = () => {
    if (
      (auth.role === "Secretária(o)" || auth.role === "Assistente") &&
      !medicoResponsavel
    ) {
      toast.error("Selecione um médico para continuar!");
      return;
    }
    if (!isSubmitting) {
      setIsSubmitting(true);
      submitHandler();
    }
  };

  const replicarTratamentoHandler = (servico) => {
    const tratamentoAReplicar = servico;

    // tratamentoAReplicar.aceitaDentes = tratamentos.find(
    //   (t) => t.id === servico.tratamento.id
    // ).aceitaDentes;

    tratamentoAReplicar.id = uuid();
    tratamentoAReplicar.tratamento = tratamentoAReplicar.tratamento.id;
    setServiceList((current) => [...current, tratamentoAReplicar]);
    setTouched(true);
  };

  const precisaPopupDentes = (shortcut) => {
    return shortcut.tratamentos.some((item) => {
      const tratamentoId =
        item.tratamento?.id ||
        item.tratamento?._id ||
        item.tratamento ||
        item.id ||
        item._id ||
        item;
      const tratamentoCompleto = tratamentos.find((t) => t.id === tratamentoId);

      if (!tratamentoCompleto) return false;

      // Não aceita dentes → não precisa popup
      if (!tratamentoCompleto.aceitaDentes) return false;

      // Tem dentes específicos
      if (tratamentoCompleto.dentesEspecificos) {
        const dentesEspecificosArray =
          tratamentoCompleto.dentesEspecificos.split(",");
        // Se tem apenas 1 dente → não precisa popup (vem automático)
        if (dentesEspecificosArray.length === 1) return false;
        // Se tem 2+ dentes → PRECISA popup
        return true;
      }

      // Aceita qualquer dente (sem restrição) → PRECISA popup
      return true;
    });
  };

  const iniciarAplicacaoShortcut = (shortcut) => {
    if (precisaPopupDentes(shortcut)) {
      // Precisa selecionar dentes primeiro
      setShortcutAtual(shortcut);
      setDentesSelecionadosShortcut([]);
      setShowDentesShortcutModal(true);
    } else {
      // Aplica direto sem popup
      aplicarShortcutHandler(shortcut, []);
    }
  };

  // const aplicarShortcutHandler = (shortcut, dentesSelecionados = []) => {
  //   const novosTratamentos = [];

  //   shortcut.tratamentos.forEach((item) => {
  //     // Extrair tratamento e quantidade
  //     const tratamentoId =
  //       item.tratamento?.id ||
  //       item.tratamento?._id ||
  //       item.tratamento ||
  //       item.id ||
  //       item._id ||
  //       item;
  //     const quantidade = item.quantidade || 1;

  //     const tratamentoCompleto = tratamentos.find((t) => t.id === tratamentoId);

  //     if (!tratamentoCompleto) {
  //       console.error(`Tratamento não encontrado: ${tratamentoId}`);
  //       return;
  //     }

  //     // Determinar quais dentes aplicar neste tratamento
  //     let dentesTratados = [];

  //     if (tratamentoCompleto.aceitaDentes) {
  //       if (tratamentoCompleto.dentesEspecificos) {
  //         const dentesEspecificosArray = tratamentoCompleto.dentesEspecificos
  //           .split(",")
  //           .map((d) => d.trim());

  //         if (dentesEspecificosArray.length === 1) {
  //           dentesTratados = dentesEspecificosArray;
  //         } else {
  //           dentesTratados = dentesSelecionados.filter((dente) =>
  //             dentesEspecificosArray.includes(dente)
  //           );
  //         }
  //       } else {
  //         dentesTratados = [...dentesSelecionados];
  //       }
  //     }

  //     let faces = [];

  //     // Adicionar o tratamento X vezes (de acordo com a quantidade)
  //     for (let i = 0; i < quantidade; i++) {
  //       novosTratamentos.push({
  //         id: uuid(),
  //         tratamento: tratamentoCompleto.id,
  //         dentesTratados: [...dentesTratados],
  //         faces: [...faces],
  //         show: true,
  //         erro: "",
  //         aceitaDentes: tratamentoCompleto.aceitaDentes,
  //       });
  //     }
  //   });

  //   // Se não foi touched, substitui tudo. Se já foi touched, adiciona aos existentes
  //   if (!touched) {
  //     setServiceList(novosTratamentos);
  //   } else {
  //     setServiceList((current) => [...current, ...novosTratamentos]);
  //   }

  //   setTouched(true); // Marca como touched após aplicar shortcut

  //   toast.success(
  //     `Atalho "${shortcut.nome}" aplicado: ${novosTratamentos.length} tratamento(s) adicionado(s)`
  //   );
  // };

  const aplicarShortcutHandler = (shortcut, dentesSelecionados = []) => {
    const novosTratamentos = [];

    // Agrupar tratamentos por ID e quantidade
    const tratamentosAgrupados = new Map();

    shortcut.tratamentos.forEach((item, index) => {
      const tratamentoId =
        item.tratamento?.id ||
        item.tratamento?._id ||
        item.tratamento ||
        item.id ||
        item._id ||
        item;
      const quantidade = item.quantidade || 1;

      const tratamentoCompleto = tratamentos.find((t) => t.id === tratamentoId);

      if (!tratamentoCompleto) {
        console.error(`  ❌ Tratamento não encontrado: ${tratamentoId}`);
        return;
      }

      // Determinar quais dentes aplicar neste tratamento
      let dentesTratados = [];

      if (tratamentoCompleto.aceitaDentes) {
        if (tratamentoCompleto.dentesEspecificos) {
          const dentesEspecificosArray = tratamentoCompleto.dentesEspecificos
            .split(",")
            .map((d) => d.trim());

          if (dentesEspecificosArray.length === 1) {
            dentesTratados = dentesEspecificosArray;
          } else {
            dentesTratados = dentesSelecionados.filter((dente) =>
              dentesEspecificosArray.includes(dente)
            );
          }
        } else {
          dentesTratados = [...dentesSelecionados];
        }
      }
      // Armazenar informações agrupadas
      if (!tratamentosAgrupados.has(tratamentoId)) {
        tratamentosAgrupados.set(tratamentoId, {
          tratamento: tratamentoCompleto,
          dentesTratados,
          quantidade,
        });
      } else {
        const existing = tratamentosAgrupados.get(tratamentoId);

        existing.quantidade += quantidade;
      }
    });

    tratamentosAgrupados.forEach((info, tratamentoId) => {});

    // Verificar se já existem tratamentos deste tipo na serviceList

    if (touched) {
      // Criar nova cópia do serviceList para modificar
      const novoServiceList = [...serviceList];
      let houveMudanca = false;

      tratamentosAgrupados.forEach((info, tratamentoId) => {
        const { tratamento, dentesTratados, quantidade } = info;

        // Buscar ÍNDICES das linhas existentes deste tratamento
        const indicesExistentes = [];
        novoServiceList.forEach((s, index) => {
          if (s.show && s.tratamento === tratamentoId) {
            indicesExistentes.push(index);
          }
        });

        if (indicesExistentes.length > 0) {
          // Determinar quantas linhas devem ser mescladas
          const linhasParaMesclar = Math.min(
            indicesExistentes.length,
            quantidade
          );
          // Mesclar apenas nas primeiras N linhas (onde N = quantidade do shortcut atual)
          for (let i = 0; i < linhasParaMesclar; i++) {
            const index = indicesExistentes[i];
            const linha = novoServiceList[index];

            // Adicionar apenas dentes que ainda não existem
            const novosUnicos = dentesTratados.filter(
              (d) => !linha.dentesTratados.includes(d)
            );

            if (novosUnicos.length > 0) {
              // Criar nova cópia do objeto linha com dentes atualizados
              novoServiceList[index] = {
                ...linha,
                dentesTratados: [...linha.dentesTratados, ...novosUnicos],
              };
              houveMudanca = true;
            }
          }

          // Verificar se precisa criar linhas adicionais
          const linhasQueFaltam = quantidade - indicesExistentes.length;

          if (linhasQueFaltam > 0) {
            for (let i = 0; i < linhasQueFaltam; i++) {
              const novaLinha = {
                id: uuid(),
                tratamento: tratamento.id,
                dentesTratados: [...dentesTratados],
                faces: [],
                show: true,
                erro: "",
                aceitaDentes: tratamento.aceitaDentes,
              };

              novosTratamentos.push(novaLinha);
            }
          } else if (linhasQueFaltam < 0) {
          }
        } else {
          // Não existem linhas - criar todas
          for (let i = 0; i < quantidade; i++) {
            const novaLinha = {
              id: uuid(),
              tratamento: tratamento.id,
              dentesTratados: [...dentesTratados],
              faces: [],
              show: true,
              erro: "",
              aceitaDentes: tratamento.aceitaDentes,
            };

            novosTratamentos.push(novaLinha);
          }
        }
      });

      // Atualizar serviceList
      if (novosTratamentos.length > 0) {
        setServiceList([...novoServiceList, ...novosTratamentos]);
      } else if (houveMudanca) {
        setServiceList(novoServiceList);
      }
    } else {
      // Primeira vez (não touched) - criar tudo do zero
      tratamentosAgrupados.forEach((info) => {
        const { tratamento, dentesTratados, quantidade } = info;

        for (let i = 0; i < quantidade; i++) {
          const novaLinha = {
            id: uuid(),
            tratamento: tratamento.id,
            dentesTratados: [...dentesTratados],
            faces: [],
            show: true,
            erro: "",
            aceitaDentes: tratamento.aceitaDentes,
          };

          novosTratamentos.push(novaLinha);
        }
      });
      setServiceList(novosTratamentos);
    }

    setTouched(true);

    toast.success(
      `Atalho "${shortcut.nome}" aplicado: ${tratamentosAgrupados.size} tipo(s) de tratamento processado(s)`
    );
  };

  const handleCancelClick = () => {
    if (serviceList.length > 1) {
      setShowCancelDialog(true);
    } else {
      navigate(`../../../clientes/${clienteId}-avaliacao`);
    }
  };

  const handleConfirmCancel = () => {
    setShowCancelDialog(false);
    navigate(`../../../clientes/${clienteId}-avaliacao`);
  };

  const handleCloseCancelDialog = () => {
    setShowCancelDialog(false);
  };

  const handleDentesShortcutChange = (event) => {
    const {
      target: { value },
    } = event;
    setDentesSelecionadosShortcut(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleConfirmarDentesShortcut = () => {
    if (dentesSelecionadosShortcut.length === 0) {
      toast.error("Selecione pelo menos um dente");
      return;
    }

    aplicarShortcutHandler(shortcutAtual, dentesSelecionadosShortcut);
    setShowDentesShortcutModal(false);
    setShortcutAtual(null);
    setDentesSelecionadosShortcut([]);
  };

  const handleCancelarDentesShortcut = () => {
    setShowDentesShortcutModal(false);
    setShortcutAtual(null);
    setDentesSelecionadosShortcut([]);
  };

  return (
    <>
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          {cliente && (
            <Navbar
              title="Criar Avaliação"
              icon={NoteAltOutlinedIcon}
              paths={[
                {
                  nome: cliente.nome,
                  link: `../../../clientes/${cliente.id}-avaliacao`,
                },
                { nome: "Novo" },
              ]}
            />
          )}
          {tratamentos &&
            serviceList &&
            cliente &&
            tratamentosAutocomplete &&
            serviceList[0].tratamento && (
              <div className="bottom-orcamento caixa">
                {(auth.role === "Secretária(o)" ||
                  auth.role === "Assistente") && (
                  <div className="avaliacaoPickMedcoContainer form-input">
                    <span className="avaliacaoPickMedcoContainer__medicoHeader">
                      Médico responsável
                    </span>
                    <select
                      id="select_medicoResponsavel"
                      name="medicoResponsavel"
                      value={medicoResponsavel}
                      onChange={(e) => setMedicoResponsavel(e.target.value)}
                      className="input"
                    >
                      <option value="">Selecione um médico</option>
                      {auth.usuariosAssociados.map((med, index) => (
                        <option value={med.id} key={index}>
                          {med.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {serviceList.map(
                  (singleService, i) =>
                    singleService.show && (
                      <div key={singleService.id} className="avaliacao__item">
                        <ElementoAvaliacao
                          //single service data
                          dentesTratados={singleService.dentesTratados}
                          faces={singleService.faces}
                          tratamento={singleService.tratamento}
                          //outros
                          tratamentos={tratamentos}
                          tratamentosAutocomplete={tratamentosAutocomplete}
                          removeService={removeService}
                          id={singleService.id}
                          dentes={DENTES}
                          show={singleService.show}
                          podeRemover={
                            serviceList.filter((s) => s.show).length > 1
                          }
                          //funcoes
                          tratamentoChangeHandler={tratamentoChangeHandler}
                          dentesChangeHandler={dentesChangeHandler}
                          facesChangeHandler={facesChangeHandler}
                          replicarTratamentoHandler={replicarTratamentoHandler}
                        />
                      </div>
                    )
                )}

                <button
                  className="add-btn"
                  onClick={addService}
                  style={{ marginLeft: "10px", marginTop: "15px" }}
                >
                  +
                </button>

                {shortcuts && shortcuts.length > 0 && (
                  <div
                    style={{
                      marginLeft: "10px",
                      marginTop: "15px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "0.9em",
                        color: "#666",
                        marginBottom: "5px",
                      }}
                    >
                      Atalhos:
                    </div>
                    <div
                      style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                    >
                      {shortcuts.map((shortcut) => (
                        <button
                          key={shortcut.id}
                          className="blue-button"
                          onClick={() => iniciarAplicacaoShortcut(shortcut)}
                          style={{ padding: "6px 12px", fontSize: "0.9em" }}
                        >
                          {shortcut.nome}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <div className="form-input mb-20">
                  <textarea
                    className="input"
                    cols="30"
                    rows="5"
                    placeholder="ESCREVA AQUI OBSERVAÇÕES ACERCA DA AVALIAÇÃO SE TIVER."
                    onChange={(e) => setObservacoes(e.target.value)}
                  ></textarea>
                </div>

                <div className="botoes">
                  <button className="cancel-btn" onClick={handleCancelClick}>
                    Cancelar
                  </button>

                  <button
                    disabled={isSubmitting}
                    className="blue-button"
                    onClick={preSubmitHandler}
                  >
                    {isSubmitting ? "Guardando..." : "Guardar"}
                  </button>
                </div>
              </div>
            )}
        </div>
      </div>

      <Dialog
        open={showCancelDialog}
        onClose={handleCloseCancelDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Cancelar avaliação?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Tem certeza que deseja cancelar? Todos os dados não guardados serão
            perdidos.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="cancel-btn" onClick={handleCloseCancelDialog}>
            Voltar
          </button>
          <button
            className="blue-button"
            onClick={handleConfirmCancel}
            autoFocus
          >
            Confirmar
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDentesShortcutModal}
        onClose={handleCancelarDentesShortcut}
        aria-labelledby="dentes-shortcut-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="dentes-shortcut-dialog-title">
          Selecionar dente(s) para: {shortcutAtual?.nome}
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: "20px" }}>
            Selecione o(s) dente(s) que serão aplicados aos tratamentos deste
            atalho.
          </DialogContentText>
          <FormControl fullWidth>
            <InputLabel id="dentes-shortcut-label">
              Dentes{" "}
              {dentesSelecionadosShortcut.length > 0
                ? `(${dentesSelecionadosShortcut.length})`
                : ""}
            </InputLabel>
            <Select
              labelId="dentes-shortcut-label"
              id="dentes-shortcut-select"
              multiple
              value={dentesSelecionadosShortcut}
              onChange={handleDentesShortcutChange}
              input={<OutlinedInput label="Dentes" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 48 * 4.5 + 8,
                    width: 250,
                  },
                },
              }}
            >
              {DENTES.map((dente) => (
                <MenuItem key={dente} value={dente}>
                  <Checkbox
                    checked={dentesSelecionadosShortcut.indexOf(dente) > -1}
                  />
                  <ListItemText primary={dente} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <button className="cancel-btn" onClick={handleCancelarDentesShortcut}>
            Cancelar
          </button>
          <button
            className="blue-button"
            onClick={handleConfirmarDentesShortcut}
            autoFocus
          >
            Aplicar
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NewAvaliacao;
